module.exports = __webpack_public_path__ + "static/media/gampsocleis_glabra_010_APA.b3cd317a.mp3";